import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Chart } from '@mc-prime/einstein-ui-components';

const config = (measure, dimension) => ({
  legend: {
    position: 'bottom',
    inside: false,
    showHeader: false
  },
  transforms: {
    rotate: true
  },
  showPoints: false,
  autoFitMode: 'fit',
  plots: [
    {
      column: [measure],
      mark: 'bar',
      color: '#00A1E0',
      axis: 'measureAxis1',
      valueType: 'none'
    },
    {
      column: ['ctor'],
      mark: 'line',
      color: '#E69F00',
      axis: 'measureAxis2'
    }
  ],
  dimensionAxis: {
    column: [dimension],
    showAxis: true,
    showTitle: false,
    title: ''
  },
  measureAxis1: {
    showAxis: true,
    showTitle: true,
    showZero: true,
    scale: 'linear',
    title: ''
  },
  measureAxis2: {
    showAxis: true,
    showTitle: true,
    showZero: true,
    scale: 'linear',
    title: ''
  }
});

class AttributeValueChart extends Component {
  rowsMetadata(dimension, measure1, measure2) {
    const { formatMessage } = this.props.intl;
    const dimensionColumns = [];
    dimensionColumns.push({
      column: dimension,
      type: 'dimension',
      label: formatMessage({
        id: `components.ecs.analytics.assetAttribute.attributeValChart.attributeValue`
      })
    });
    const measureColumns = [];
    measureColumns.push({
      column: measure1,
      type: 'measure',
      label: formatMessage({
        id: `components.ecs.analytics.assetAttribute.attributeValChart.columns.${measure1}`
      }),
      format: ['###%', 100]
    });
    measureColumns.push({
      column: measure2,
      type: 'measure',
      label: formatMessage({
        id: `components.ecs.analytics.assetAttribute.attributeValChart.columns.${measure2}`
      })
    });

    return [...dimensionColumns, ...measureColumns];
  }

  attributeValue() {
    return Object.keys(this.props.attributes[0])[0];
  }

  graphRows() {
    const { formatMessage } = this.props.intl;
    const attrValue = this.attributeValue();
    return this.props.attributes.map(attribute => {
      if (attribute[attrValue] === null) {
        attribute[attrValue] = formatMessage({
          id: 'components.ecs.assetFilter.empty'
        });
      }
      return attribute;
    });
  }

  render() {
    if (this.props.attributes.length < 1) return null;
    const { measure } = this.props;
    const attrValue = this.attributeValue();

    return (
      <div className="perf-chart-container">
        <div className="chart" style={{ height: '500px' }}>
          <Chart
            className="wave-chart-component"
            chartModule="sfdc-bar-chart"
            modulePrefix="../"
            config={config(measure, attrValue)}
            rows={this.graphRows()}
            rowsMetadata={this.rowsMetadata(attrValue, 'ctor', measure)}
          />
        </div>
      </div>
    );
  }
}

AttributeValueChart.propTypes = {
  actions: PropTypes.object,
  attributes: PropTypes.array,
  filter: PropTypes.object,
  details: PropTypes.array,
  location: PropTypes.object
};

export default injectIntl(AttributeValueChart);
